<div class="flex flex-col -m-6" style="width: 60vw !important; height: 100%">
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">
      {{ "NOTIFICATION.NOTIFICATION_DETAIL" | transloco }}
    </div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>
  <div style="
      max-height: calc(100vh - 150px);
      overflow: auto;
      background-color: #eaeaea !important;
    ">
    <div class="bg-white pl-4 pt-2 h-20 max-h-24 min-h-20" style="border-bottom: 1px solid grey !important">
      <div class="flex justify-between items-center">
        <div class="font-semibold truncate">
          {{ "NOTIFICATION.LABEL.FROM" | transloco }}:
          {{ data?.detailNotification.msgFrom }}
        </div>
        <div class="font-semibold truncate mr-4">
          {{ data?.detailNotification.createDate | dateTimeFormatPipe }}
        </div>
      </div>
      <div class="font-medium truncate flex">
        <div>
          {{ "NOTIFICATION.LABEL.TO" | transloco }}:
          {{ data?.detailNotification.msgTo }}
        </div>
      </div>
      <div *ngIf="data?.detailNotification.msgTitle" class="font-semibold truncate">
        <span> {{ "NOTIFICATION.LABEL.TITLE" | transloco }}: </span>
        <span class="ml-1" [innerHTML]="data?.detailNotification.msgTitle | keepHtmlExtend">
        </span>
      </div>
    </div>
    <div class="p-4 self-center">
      <div class="custom-html-wrapper" *ngIf="msgContent" [innerHTML]="msgContent | keepHtmlExtend"></div>
    </div>
  </div>
</div>